import { createZodFormResolver, Form, FormInputField, lt } from '@mews/framework';
import { useCommanderSelector } from '@mews-commander/utils';
import { getReservationGroupName } from '@mews-commander/legacy-entities/src/ducks';
import { WithScope } from '@mews-commander/types';
import { FormLayout } from '../../FormLayout';
import { GroupNameFormKeys, groupNameFormSchema } from './types';
import { useChangeGroupNameMutation } from './useChangeGroupNameMutation';

const EMPTY = '';

export const GroupNameForm = ({ scope, onSuccess }: WithScope & { onSuccess?: () => void }) => {
    const defaultGroupName = useCommanderSelector((state) => getReservationGroupName(state, { id: scope })) ?? EMPTY;

    const { mutate, isPending } = useChangeGroupNameMutation({
        groupId: scope,
    });

    return (
        <Form
            onSubmit={(v) => {
                mutate(v, {
                    onSuccess,
                });
            }}
            resolver={createZodFormResolver(groupNameFormSchema)}
            dataTestForm="group-name-form"
            defaultValues={{
                [GroupNameFormKeys.groupName]: defaultGroupName,
            }}
        >
            <FormLayout
                vertical
                loading={isPending}
                submitButtonText={lt('ChangeName')}
                title={lt('ReservationGroupName')}
            >
                <FormInputField label={lt('Name')} name={GroupNameFormKeys.groupName} />
            </FormLayout>
        </Form>
    );
};
